import type { FeedbackPost } from 'epic/missed-deal-feedback/submit-feedback';
import type { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs/operators';
import type { FeedbackAck, MissedFeedbackCompetitionParameter } from 'state/missed-deal-feeedback/feedback/model';
import type { PriceEnhancement } from 'state/quotes/trades/trades.model';
import type { IHttpClient } from 'utils/http.old/httpClient.model';

export type MissedFeedbackParameters = {
  parameters: MissedFeedbackCompetitionParameter[];
  initialPriceEnhancement: PriceEnhancement;
};

export function missedDealFeedbackConnector(httpClient: IHttpClient) {
  return {
    fetchAllCompetitionParameters(pricerId: string): Observable<MissedFeedbackParameters> {
      return httpClient
        .getJSON<MissedFeedbackParameters>({
          url: `api/v1/missed-feedback/${pricerId}`,
          targetHost: 'AdvisoryBridge',
        })
        .pipe(map(r => r.payload));
    },
    submitFeedback(feedback: FeedbackPost) {
      return httpClient
        .post<FeedbackAck>({
          url: `api/v1/missed-feedback`,
          body: feedback,
          targetHost: 'AdvisoryBridge',
        })
        .pipe(map(r => r.payload));
    },
  };
}
